module.exports = __webpack_public_path__ + "img/ir.6a991632.svg";